<template>
    <div v-if="user.name">
        <h3 class="order__subtitle cart__subtitle">Данные контактного лица</h3>
        <div class="cart__wrap"
             :data-element="$root.getDataElement('account')">
            <div class="cart__row">
                <div class="cart__grow">
                    <div :data-element="$root.getDataElement('name')">{{ user.name }}</div>
                </div>
            </div>
            <div class="cart__row">
                <div class="cart__grow">
                    <a :href="'mailto:' + user.email"
                       class="cart__email"
                       :data-element="$root.getDataElement('email')"
                    >
                        {{ user.email }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../../../lib/api";
export default {
    name: "UserComponent",
    data() {
        return {
            user: {},
            loader: true,
        }
    },
    methods: {
        createLoader(bool) {
            this.loader = bool;
            this.$emit('createLoader', 'user', this.loader)
        }
    },
    mounted: function () {
        this.createLoader(true)

        api.request('/api/cart-confirm/getAuthUser/', 'get').then((response) => {
            this.user = response.data;
            this.createLoader(false);
        }).catch(() => {
            this.createLoader(false);
        });
    }
}
</script>
